import { memo, useContext, useId } from 'react';
import { useTranslation } from 'react-i18next';
import FieldSetupPanelContext from './field-setup-panel.context';
import type { TimePickerConfigProps } from './types';
import CmTimePicker from '../cm-control-ui/cm-time-picker';

/**
 * Time Picker setup (Figma "Time Picker CM"): the Options tab holds the Default Time the field starts
 * on; title and the Setup toggles live on the setup card itself.
 * @param value - Current time picker configuration.
 * @param onChange - Called with the updated configuration.
 * @param disabled - Whether the input is locked.
 * @returns The Options tab content, or nothing on the Setup tab.
 */
function TimePickerConfig({ value, onChange, disabled = false }: TimePickerConfigProps) {
  const { t } = useTranslation('custom-module-system-canvas');
  const setupPanel = useContext(FieldSetupPanelContext);
  const timeId = useId();

  if (setupPanel === 'setup') return null;

  return (
    <div className="cm-text-options__limit">
      <CmTimePicker id={timeId} value={value.defaultTime} onChange={(defaultTime) => onChange({ ...value, defaultTime })} disabled={disabled} />
      <label className="cm-text-options__hint" htmlFor={timeId}>
        {t('CUSTOM_MODULE.SYSTEM_CANVAS.CONTROLS.TIME_PICKER.DEFAULT_TIME')}
      </label>
    </div>
  );
}

export default memo(TimePickerConfig);
